import { v4 as uuidv4 } from 'uuid';

export function ProductBrand(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductBrand',
		componentId: uuidv4(),
		props: Object.assign(
			{
				mzImage: 'https://maeztraio.vtexassets.com/arquivos/ids/156857-auto-32?width=auto&height=32&aspect=true',
				displayMode: 'logo',
				fallbackToText: false,
				height: 100,
				loadingPlaceholder: 'logo',
			},
			props,
		),
		childrenComponents,
	};
}
